import React from "react";
import { Mail, Loader2, Check } from "lucide-react";
import { subscribeNewsletter } from "../lib/api";

function SubmitIcon({ state }) {
  if (state === "loading") return <Loader2 size={16} className="animate-spin" />;
  if (state === "success") return <Check size={16} />;
  return "Subscribe";
}

function messageClass(state, dark) {
  if (state === "error") return "text-[#C25555]";
  if (dark) return "text-white/75";
  return "text-[#4A4A4A]";
}

export default function NewsletterForm({ dark, testId = "newsletter" }) {
  const [email, setEmail] = React.useState("");
  const [state, setState] = React.useState("idle"); // idle | loading | success | error
  const [message, setMessage] = React.useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setState("loading");
    try {
      const r = await subscribeNewsletter({ email, source: testId });
      setState("success");
      setMessage(r.message || "Check your inbox to confirm.");
    } catch (err) {
      setState("error");
      setMessage(
        err?.response?.data?.detail || "Couldn't subscribe. Try again."
      );
    }
  };

  const c = dark
    ? "bg-white/5 border-white/15 text-white placeholder-white/55 focus:border-white/40"
    : "lr-input";

  return (
    <form
      onSubmit={onSubmit}
      className="flex flex-col gap-3"
      data-testid={`${testId}-form`}
    >
      <label
        className={`font-sans-tight text-[12px] tracking-[0.18em] uppercase font-semibold ${
          dark ? "text-[#E07B3A]" : "text-[#1A1A1A]"
        }`}
      >
        Newsletter
      </label>
      <div className="flex gap-2">
        <div className="flex-1 relative">
          <Mail
            size={16}
            className={`absolute left-3 top-1/2 -translate-y-1/2 ${
              dark ? "text-white/60" : "text-[#4A4A4A]"
            }`}
          />
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            data-testid={`${testId}-email-input`}
            className={`${c} ${dark ? "px-10 py-3 border w-full text-[14px]" : "lr-input pl-10"}`}
            disabled={state === "loading" || state === "success"}
          />
        </div>
        <button
          type="submit"
          disabled={state === "loading" || state === "success"}
          data-testid={`${testId}-submit-button`}
          className={`btn ${dark ? "btn-primary" : "btn-dark"} px-5`}
        >
          {<SubmitIcon state={state} />}
        </button>
      </div>
      {message && (
        <p
          className={`font-serif-body text-[13.5px] ${messageClass(state, dark)}`}
          data-testid={`${testId}-status`}
        >
          {message}
        </p>
      )}
      <p
        className={`font-serif-body text-[12px] ${
          dark ? "text-white/55" : "text-[#4A4A4A]"
        }`}
      >
        Double opt-in. We'll send one email to confirm. Unsubscribe in one
        click.
      </p>
    </form>
  );
}
